export default {
  data() {
    return {
      searchSchema: [
        {
          label: '评分时间',
          itemName: 'startDate',
          type: 'rangePicker',
          allowClear: true,
        },
        {
          label: '客户名称',
          itemName: 'name',
          type: 'input',
          allowClear: true,
        },
      ],
      searchData: {
        name: '',
        status: '',
      },
      columns: [
        {
          title: '变量',
          dataIndex: 'name',
          width: 120,
        },
        {
          title: '数据类型',
          dataIndex: 'type',
          width: 120,
        },
        {
          title: '指标信息',
          dataIndex: 'value',
          width: 100,
        },
        {
          title: '指标得分',
          dataIndex: 'score',
          width: 120,
        },
        {
          title: '指标权重',
          dataIndex: 'wright',
          width: 120,
        },
        {
          title: '加权后得分',
          dataIndex: 'bs',
          width: 120,
        },
        // {
        //   title: '总分',
        //   dataIndex: 'score',
        //   width: 120
        // }
      ],
    }
  },
}
